const baseStyle = {
  color: 'rgba(67, 90, 111, 0.47)'
}

const appearances = {}
const sizes = {
  small: {
    width: 32,
    height: 32
  },
  medium: {
    width: 40,
    height: 40
  },
  large: {
    width: 48,
    height: 48
  }
}

export default {
  baseStyle,
  appearances,
  sizes
}
